 
import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";
import DynamicMaster from "../Components/DynamicMaster/DynamicMaster";
import { FormInstance } from "antd";

export default function DynamicFormAllControl() {
  const formRef = useRef<FormInstance>(null);
  const reportActionHandler = {

  };
  const rowActionHandler = {

  };

  const interfaceActionHandler = {
    handleSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleSubmit run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      //return true;
    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      //return true;
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 409 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };

  const interfaceFieldActionHandler = {


  };



  return (
 
      <ActionHandlerProvider
        rowActionHandler={rowActionHandler}
        reportActionHandler={reportActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
        <DynamicMaster
          InterfaceName={"Dynamic Form Control"}
          DashboardName={"Dynamic Control Dashboard"}
          ref={formRef}
        />
        {/* <DynamicMaster InterfaceName={'User Access Master'} DashboardName={'User Access Master'} ref={formRef}/> */}
      </ActionHandlerProvider>

     
  );
}
